// assets/luxury-marquee.js
// <luxury-marquee>: cinta de texto infinita con shimmer dorado.
// El movimiento es 100% CSS (@keyframes); este JS solo controla pausa (hover + fuera de viewport).

(function () {
  'use strict';

  if (customElements.get('luxury-marquee')) return;

  class LuxuryMarquee extends HTMLElement {
    connectedCallback() {
      this._io = new IntersectionObserver(
        (entries, obs) => {
          if (!entries[0].isIntersecting) return;
          obs.disconnect();
          this.init();
        },
        { rootMargin: '200px' }
      );
      this._io.observe(this);

      this._fallback = setTimeout(() => {
        if (!this._initialized) this.init();
      }, 1500);
    }

    init() {
      if (this._initialized) return;
      this._initialized = true;
      clearTimeout(this._fallback);

      this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
      this._hoverPaused = false;
      this._offscreenPaused = false;

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => {
          this._hoverPaused = true;
          this.updatePauseState();
        });
        this.addEventListener('mouseleave', () => {
          this._hoverPaused = false;
          this.updatePauseState();
        });
      }

      // Pausa también cuando la sección sale completamente de pantalla, para no gastar
      // ciclos de animación en algo que el usuario no ve (buena práctica de rendimiento).
      this._visibilityObserver = new IntersectionObserver(
        (entries) => {
          this._offscreenPaused = !entries[0].isIntersecting;
          this.updatePauseState();
        },
        { threshold: 0 }
      );
      this._visibilityObserver.observe(this);
    }

    updatePauseState() {
      const shouldPause = this._hoverPaused || this._offscreenPaused;
      this.setAttribute('data-paused', shouldPause ? 'true' : 'false');
    }

    disconnectedCallback() {
      this._io?.disconnect();
      this._visibilityObserver?.disconnect();
    }
  }

  customElements.define('luxury-marquee', LuxuryMarquee);
})();